import React from "react";
import ReactDOM from "react-dom/client";
import { ErrorBoundary } from "@/sentry"; // loads Sentry only if REACT_APP_SENTRY_DSN is set
import "@/index.css";
import "@/dark-tints.css";
import "@/styles/mobile-fit.css";
import "@/i18n"; // initialize i18next
import App from "@/App";
import { registerServiceWorker } from "@/serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary fallback={<div style={{padding:'24px',fontFamily:'system-ui'}}>Something went wrong. Please refresh the page.</div>}>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);

registerServiceWorker();
